// @ts-nocheck
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
import Utils from './utils/Utils';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    fr: {
        translation: translationFR
    },
    es: {
        translation: translationES
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: Utils.getCurrentLanguage(),

        keySeparator: false,

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;